import React from 'react';
import {connect} from 'react-redux';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import ReduxToastr from 'react-redux-toastr';
import {LoadingPage} from 'components/loading-page';
import {SendRequest} from 'components/partials/product/send-request';
import {ProductPopupDetail} from 'components/partials/product/popup-view-detail';

class MasterLayout extends React.Component {

  render() {
    const childrenWithProps = React.Children.map(this.props.children, (child) => React.cloneElement(child, {}));
    return (
      <div className={`wrapper-container ${this.props.pageClass} ${this.props.hasBreadcrumb ? 'has-breadscrum' : ''}`} style={this.props.backgroundImage ? {backgroundImage: this.props.backgroundImage} : {}}>
        <Header isActive={this.props.isActive} classBreadcrumb={this.props.classBreadcrumb}/>
        {this.props.isOpenForm && <SendRequest/>}
        {this.props.isOpenPopup && <ProductPopupDetail />}
        {this.props.isLoadingPopup && <LoadingPage isShow={this.props.isLoadingPopup} />}
        <ReduxToastr
          timeOut={4000}
          newestOnTop={true}
          preventDuplicates={true}
          transitionIn="bounceIn"
          transitionOut="bounceOut"
          progressBar={true}
        />
        <div className="main-container" id='main'>
          {childrenWithProps}
        </div>
        <Footer/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpenPopup: state.popupProduct.isOpen,
    isLoadingPopup: state.popupProduct.isLoading,
    isOpenForm: state.popupProduct.isOpenForm,
    hasBreadcrumb: state.breadcrumb.hasBreadcrumb
  };
};

export default connect(mapStateToProps)(MasterLayout);



// WEBPACK FOOTER //
// ./components/layouts/master/MasterLayout.jsx